import { useState } from 'nuxt/app';
import { computed } from 'vue';

export function useApplicationCode() {
	const codeState = useState<string>('HMapplicationCode');

	function setApplicationCode(code: string) {
		codeState.value = code;
	}

	const canSwitchOnboardingType = computed(() => [undefined, 'cam', 'mar', 'mobile'].includes(codeState.value));

	return {
		setApplicationCode,
		applicationCode: computed(() => codeState.value),
		htmlClass: computed(() => codeState.value === 'mobile' ? `html--mobile-app` : ''),
		canSwitchOnboardingType,
	};
}
